// import React from 'react';
// import { Container, Row, Col, Button } from 'react-bootstrap';
// // Assuming RenderControlData is provided from a base file in the project
// import { RenderControlData } from './RenderControlData.js';
// // Assuming String is provided by the schema library as per the CTA example's outline

// /**
//  * HeroBanner React Component
//  *
//  * This component renders a full-width hero section with a background image,
//  * a prominent title, and a call-to-action button, styled according to the
//  * provided image.
//  *
//  * Props:
//  * @param {string} backgroundImage - URL or path to the background image. Defaults to '/forest_back.png'.
//  * @param {string} title - The main headline text. Defaults to 'THE FUTURE OF MEDIA IS HERE'.
//  * @param {string} buttonLabel - Text displayed on the call-to-action button. Defaults to 'JOIN THE WAITLIST'.
//  * @param {string} buttonHref - The URL the button links to. Defaults to '#'.
//  * @param {string} titleColor - CSS color string for the title text. Defaults to '#E0E0E0' (soft light gray).
//  * @param {string} buttonBackgroundColor - CSS color string for the button's background. Defaults to '#C7A24B' (muted golden-brown).
//  * @param {string} buttonTextColor - CSS color string for the button's text. Defaults to '#2D2D2D' (dark gray).
//  * @param {string} overlayColor - CSS color string for the semi-transparent overlay on the background image. Defaults to 'rgba(0, 0, 0, 0.6)'.
//  */
// // const ArtlabBanner = ({
// //   backgroundImage = '/forest_back.png', // Default placeholder image
// //   title = 'THE FUTURE OF MEDIA IS HERE',
// //   buttonLabel = 'JOIN THE WAITLIST',
// //   buttonHref = '#',
// //   titleColor = '#E0E0E0', // Adjusted: soft light gray
// //   buttonBackgroundColor = '#C7A24B', // Adjusted: muted golden-brown
// //   buttonTextColor = '#2D2D2D', // Adjusted: dark gray
// //   overlayColor = 'rgba(0, 0, 0, 0.4)' // Adjusted: increased overlay opacity
// // }) => {

// const ArtlabBanner = ({ section }) => {
//   const {
//     backgroundImage = '/forest_back.png',
//     title = 'THE FUTURE OF MEDIA IS HERE',
//     buttonLabel = 'JOIN THE WAITLIST',
//     buttonHref = '#',
//     titleColor = '#E0E0E0',
//     buttonBackgroundColor = '#C7A24B',
//     buttonTextColor = '#2D2D2D',
//     overlayColor = 'rgba(0, 0, 0, 0.4)',
//   } = section || {};

//   // Styles for the main section container, providing structure and centering
//   const sectionStyle = {
//     position: 'relative',
//     height: '100vh', // Increased height
//     display: 'flex',
//     alignItems: 'center', // Vertically centers content within the section - combined with Row's margin-top for desired vertical shift
//     justifyContent: 'center', // Horizontally centers content within the section
//     overflow: 'hidden', // Ensures background image doesn't spill
//     textAlign: 'center', // Centers text and inline elements
//     background: 'none', // Override any default background
//     // Removed: border: '1px solid rgba(255, 255, 255, 0.1)', // Removed outer white border
//   };

//   // Styles for the background image, ensuring it covers the entire section
//   const backgroundStyle = {
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     width: '100%',
//     height: '100%',
//     objectFit: 'cover', // Covers the area without distorting aspect ratio
//     zIndex: -2, // Positions image behind overlay and content
//   };

//   // Styles for the semi-transparent dark overlay, enhancing text readability
//   const overlayStyle = {
//     position: 'absolute',
//     top: 0,
//     left: 0,
//     width: '100%',
//     height: '100%',
//     backgroundColor: overlayColor, // Customizable overlay color
//     zIndex: -1, // Positions overlay above image, behind content
//   };

//   // Styles for the main title text
//   const titleStyle = {
//     color: titleColor, // Customizable text color
//     fontSize: 'clamp(2.2rem, 4vw, 4.2rem)', // Adjusted: slightly reduced font size
//     fontWeight: '800', // Adjusted: decreased font weight
//     textTransform: 'uppercase', // Uppercase text as seen in the image
//     marginBottom: '1.5rem', // Adjusted margin bottom for separator
//     lineHeight: 1.2, // Adjusted line height
//     letterSpacing: '1.5px', // Adjusted: tighter letter spacing
//     //textShadow: '0 0 10px rgba(0, 0, 0, 0.3)', // Added text shadow
//   };

//   // Styles for the call-to-action button
//   const buttonStyle = {
//     backgroundColor: buttonBackgroundColor, // Now uses prop for background color
//     color: buttonTextColor, // Text color (defaults to black)
//     borderColor: buttonBackgroundColor, // Adjusted: border matches background color
//     borderWidth: '1px', // Adjusted border width
//     borderStyle: 'solid', // Ensure solid border
//     fontWeight: 500, // Adjusted font weight
//     padding: '0.6rem 2.0rem', // Adjusted: slightly more compact padding
//     fontSize: '0.9rem', // Adjusted: slightly reduced font size
//     borderRadius: '4px', // Adjusted: less rounded appearance
//     letterSpacing: '0.5px', // Added letter spacing
//   };

//   return (
//     <section style={sectionStyle}>
//       {/* Background Image Element */}
//       <img src={backgroundImage} alt="Forest Background" style={backgroundStyle} className='rounded-5'/>
//       {/* Dark Overlay Element */}
//       <div style={overlayStyle}  className='rounded-5'></div>
//       {/* Content Container: Title and Button */}
//       <Container className="h-100 d-flex align-items-center justify-content-center ">
//         <Row className="justify-content-center">
//           <Col xs={12} md={10} lg={8}>
//             <h1  style={titleStyle}   className="display-1 ">{title}</h1>
//             {/* Added separator line */}
//             <div style={{
//               width: '60px',
//               height: '1px',
//               backgroundColor: 'rgba(255, 255, 255, 0.12)', // Adjusted: more subtle separator
//               margin: '1.5rem auto 1rem auto'
//             }}></div>
//             <Button href={buttonHref} style={buttonStyle}>
//               {buttonLabel}
//             </Button>
//           </Col>
//         </Row>
//       </Container>
//     </section>
//   );
// };

// /**
//  * HeroBannerData Class
//  *
//  * This class defines the schema for the HeroBanner component's data,
//  * extending the base RenderControlData class. It is used for validation
//  * and consistent data modeling across the application.
//  */
// class ArtlabBannerData extends RenderControlData {
//   static annotations = Object.assign({}, RenderControlData.annotations, {
//     // 'render_control_type' is typically defined in RenderControlData.annotations
//     // and inherited. We list specific props for HeroBanner here.
//     backgroundImage: String,
//     title: String,
//     buttonLabel: String,
//     buttonHref: String,
//     titleColor: String,
//     buttonBackgroundColor: String,
//     buttonTextColor: String,
//     overlayColor: String,
//   });
// }

// export { ArtlabBanner, ArtlabBannerData };
// export default ArtlabBanner;


import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { RenderControlData } from './RenderControlData.js';


// NEW — YouTube background support
// const iframeStyleDefault = {
//   position: 'absolute',
//   top: '50%',
//   left: '50%',
//   width: '100vw',
//   height: '56.25vw',
//   minWidth: '177.78vh',
//   minHeight: '100%',
//   transform: 'translate(-50%, -50%)',
//   border: 0,
// };
// CHANGED
const iframeStyleDefault = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  width: '100vw',
  height: '56.25vw',
  minWidth: '177.78vh',
  minHeight: '100%',
  transform: 'translate(-50%, -50%)',
  border: 0,
  zIndex: -2,          // NEW — keep behind overlay + content
  pointerEvents: 'none'// NEW — iframe can’t steal clicks (button works)
};



// NEW
function _getYouTubeId(url) {
  if (!url || typeof url !== 'string') return null;
  const s = url.trim();

  // youtu.be/<id>
  let m = s.match(/youtu\.be\/([A-Za-z0-9_-]{6,})/);
  if (m && m[1]) return m[1];

  // youtube.com/watch?v=<id>
  m = s.match(/[?&]v=([A-Za-z0-9_-]{6,})/);
  if (m && m[1]) return m[1];

  // youtube.com/embed/<id>
  m = s.match(/youtube\.com\/embed\/([A-Za-z0-9_-]{6,})/);
  if (m && m[1]) return m[1];

  // youtube.com/shorts/<id>
  m = s.match(/youtube\.com\/shorts\/([A-Za-z0-9_-]{6,})/);
  if (m && m[1]) return m[1];

  return null;
}

// NEW
function _toYouTubeLoopEmbedUrl(videoId) {
  if (!videoId) return null;
  return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&controls=0&playlist=${videoId}&modestbranding=1&playsinline=1&rel=0`;
}


/**
 * HeroBanner React Component
 *
 * Props are read from `section`.
 *
 * section fields:
 * @param {string} backgroundImage
 * @param {string} title
 * @param {string} buttonLabel
 * @param {string} buttonHref
 * @param {string} titleColor
 * @param {string} buttonBackgroundColor
 * @param {string} buttonTextColor
 * @param {string} overlayColor
 * @param {string} contentDock - "center" | "lower-left" | "lower-right"
 */

const ArtlabBanner = ({ section }) => {
  const {
    backgroundImage = '/forest_back.png',
    title = 'THE FUTURE OF MEDIA IS HERE',
    buttonLabel = 'JOIN THE WAITLIST',
    buttonHref = '#',
    titleColor = '#E0E0E0',
    buttonBackgroundColor = '#C7A24B',
    buttonTextColor = '#2D2D2D',
    overlayColor = 'rgba(0, 0, 0, 0.4)',
    contentDock = 'center', // NEW
  } = section || {};

  let sectionAlignItems = 'center';
  let sectionJustifyContent = 'center';
  let sectionTextAlign = 'center';

  let containerClassName = 'h-100 d-flex align-items-center justify-content-center pb-0';
  let rowClassName = 'justify-content-center';
  let separatorMargin = '1.5rem auto 1rem auto';

  if (contentDock === 'lower-left') {
    sectionAlignItems = 'flex-end';
    sectionJustifyContent = 'flex-start';
    sectionTextAlign = 'left';

    containerClassName = 'h-100 d-flex align-items-end justify-content-star pb-0 mb-0 pb-md-3 mb-md-3 ';
    rowClassName = 'justify-content-start';
    separatorMargin = '1.5rem 0 1rem 0';
  }
  else if (contentDock === 'lower-right') {
    sectionAlignItems = 'flex-end';
    sectionJustifyContent = 'flex-end';
    sectionTextAlign = 'right';

    containerClassName = 'h-100 d-flex align-items-end justify-content-end';
    rowClassName = 'justify-content-end';
    separatorMargin = '1.5rem 0 1rem auto';
  }

  // const sectionStyle = {
  //   position: 'relative',
  //   height: '80vh',
  //   display: 'flex',
  //   alignItems: sectionAlignItems,
  //   justifyContent: sectionJustifyContent,
  //   overflow: 'hidden',
  //   textAlign: sectionTextAlign,
  //   background: 'none',
  // };
// CHANGED
const sectionStyle = {
  position: 'relative',
  height:'80vh',
  display: 'flex',
  alignItems: sectionAlignItems,
  justifyContent: sectionJustifyContent,
  overflow: 'hidden',
  isolation: 'isolate', 
  textAlign: sectionTextAlign,
  background: 'none',
};



  const backgroundStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    zIndex: -2,
  };

  const overlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: overlayColor,
    zIndex: -1,
  };

  const titleStyle = {
    color: titleColor,
    fontSize: 'clamp(2.2rem, 4vw, 4.2rem)',
    fontWeight: '800',
    textTransform: 'uppercase',
    marginBottom: '1.5rem',
    lineHeight: 1.2,
    letterSpacing: '1.5px',
  };

  const titleStyleMobile = {
    color: 'rgb(35, 35, 35)',
    fontSize: 'clamp(2.2rem, 4vw, 4.2rem)',
    fontWeight: '800',
    textTransform: 'uppercase',
    marginBottom: '1.5rem',
    lineHeight: 1.2,
    letterSpacing: '1.5px',
  };
  const buttonStyle = {
    backgroundColor: buttonBackgroundColor,
    color: buttonTextColor,
    borderColor: buttonBackgroundColor,
    borderWidth: '1px',
    borderStyle: 'solid',
    fontWeight: 500,
    padding: '0.6rem 2.0rem',
    fontSize: '0.9rem',
    borderRadius: '4px',
    letterSpacing: '0.5px',
  };

// Mobile styles
// NEW — mobile square media
// const mobileMediaWrapStyle = {
//   position: 'relative',
//   width: '100%',
//   aspectRatio: '1 / 1',
//   overflow: 'hidden',
// };
// CHANGED
const mobileMediaWrapStyle = {
  position: 'relative',
  width: '100%',
  aspectRatio: '1 / 1',
  overflow: 'hidden',
  borderRadius: '2rem', // NEW — matches Bootstrap rounded-5 in most themes
};

const mobileImgStyle = {
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
};

// NEW — “cover” crop for 16:9 YouTube inside a square
const mobileIframeCoverStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  width: '204%',                  // was 177.78%  (177.78 * 1.15)
  height: '115%',                 // was 100%     (1.15x)
  transform: 'translate(-50%, -54%)', // was -50%, -50% (slight up-bias)
  border: 0,
  pointerEvents: 'none',
};



// NEW
const ytId = _getYouTubeId(backgroundImage);
const ytEmbedUrl = ytId ? _toYouTubeLoopEmbedUrl(ytId) : null;


// NEW (inside component, near other styles)
const mobileSectionStyle = {
  position: 'relative',
  background: 'none',
  overflow: 'hidden',
  border: '1px solid rgba(255, 255, 255, 0.10)',
};

const mobileOverlayStyle = {
  position: 'absolute',
  inset: 0,
  backgroundColor: overlayColor,
};

// CHANGED
return (
  <>
    {/* Desktop: existing overlay hero d-block d-md-none*/}
    <section
      style={{ ...sectionStyle, border: '1px solid rgba(255, 255, 255, 0.10)' }}
      className="rounded-5 ratio ratio-1x1 d-md-flex artlab-banner--mobile-square"
    >
      {ytEmbedUrl ? (
        <iframe
          title="Hero Background Video"
          src={ytEmbedUrl}
          style={iframeStyleDefault}
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
        />
      ) : (
        <img
          src={backgroundImage}
          alt="Forest Background"
          style={backgroundStyle}
          className="rounded-5"
        />
      )}

      <div style={overlayStyle} className="rounded-5  "></div>

      <Container className={containerClassName} style={{ position: 'relative', zIndex: 1 }}>
        <Row className={rowClassName}>
          <Col xs={12} md={10} lg={8} >
            <h1 style={titleStyle} className="display-1 artlab-banner__title ">{title}</h1>

            <div   className="  artlab-banner__divider " style={{
              width: '60px',
              height: '1px',
              backgroundColor: 'rgba(255, 255, 255, 0.12)',
              margin: separatorMargin
            }}></div>

            <Button href={buttonHref} style={buttonStyle}>
              {buttonLabel}
            </Button>
          </Col>
        </Row>
      </Container>
    </section>

  </>
);

  // return (
  //   <section style={{ ...sectionStyle, borderRadius: '2rem' }}>
  //     {/* CHANGED — background supports image OR YouTube */}
  //     {ytEmbedUrl ? (
  //       <iframe
        
  //         title="Hero Background Video"
  //         src={ytEmbedUrl}
  //         style={iframeStyleDefault}
  //         allow="autoplay; fullscreen; picture-in-picture"
  //         allowFullScreen
  //       />
  //     ) : (
  //       <img src={backgroundImage} alt="Forest Background" style={backgroundStyle} className='rounded-5' />
  //     )}
      
  //     <div style={overlayStyle} className='rounded-5'></div>

  //     <Container className={containerClassName}>
  //       <Row className={rowClassName}>
  //         <Col xs={12} md={10} lg={8}>
  //           <h1 style={titleStyle} className="display-1">{title}</h1>

  //           <div style={{
  //             width: '60px',
  //             height: '1px',
  //             backgroundColor: 'rgba(255, 255, 255, 0.12)',
  //             margin: separatorMargin
  //           }}></div>

  //           <Button href={buttonHref} style={buttonStyle}>
  //             {buttonLabel}
  //           </Button>
  //         </Col>
  //       </Row>
  //     </Container>
  //   </section>
  // );
};

class ArtlabBannerData extends RenderControlData {
  static annotations = Object.assign({}, RenderControlData.annotations, {
    backgroundImage: String,
    title: String,
    buttonLabel: String,
    buttonHref: String,
    titleColor: String,
    buttonBackgroundColor: String,
    buttonTextColor: String,
    overlayColor: String,
    contentDock: String, // NEW
  });
}

export { ArtlabBanner, ArtlabBannerData };
export default ArtlabBanner;
